(function () {
  const initializedRoots = new WeakSet();
  let globalListenersAttached = false;

  function getOpenPopovers() {
    return document.querySelectorAll(
      '[data-c-product-line-notification-popover]:popover-open'
    );
  }

  function updatePopoverPositionForRoot(root) {
    if (!root) return;

    const popoverId = root.dataset.popoverId;
    if (!popoverId) return;

    const popover = document.getElementById(popoverId);
    if (!popover || !popover.matches(':popover-open')) return;

    const rootRect = root.getBoundingClientRect();

    popover.style.position = 'fixed';
    popover.style.top = `${rootRect.top}px`;
    popover.style.left = `${rootRect.left}px`;
    popover.style.width = `${rootRect.width}px`;
    popover.style.maxWidth = `${rootRect.width}px`;
    popover.style.zIndex = '9999';
  }

  function updateAllOpenPopovers() {
    getOpenPopovers().forEach((popover) => {
      const root = popover.__cLineNotificationRoot;
      updatePopoverPositionForRoot(root);
    });
  }

  function attachGlobalListenersOnce() {
    if (globalListenersAttached) return;

    const handleViewportChange = () => {
      updateAllOpenPopovers();
    };

    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('scroll', handleViewportChange, true);
    globalListenersAttached = true;
  }

  function initRoot(root) {
    if (!root || initializedRoots.has(root)) return;

    const popoverId = root.dataset.popoverId;
    if (!popoverId) return;

    const popover = document.getElementById(popoverId);
    if (!popover) return;

    popover.__cLineNotificationRoot = root;

    popover.addEventListener('toggle', (event) => {
      if (event.newState !== 'open') return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updatePopoverPositionForRoot(root);
        });
      });
    });

    initializedRoots.add(root);
  }

  function initWithin(scope) {
    if (!scope) return;

    const roots = scope.matches?.('[data-c-product-line-notification]')
      ? [scope]
      : scope.querySelectorAll('[data-c-product-line-notification]');

    roots.forEach((root) => initRoot(root));
    attachGlobalListenersOnce();
  }

  document.addEventListener('DOMContentLoaded', () => {
    initWithin(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });
})();
